import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, Checkbox, FormControlLabel } from '@material-ui/core';
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import InputField from "../../componentes/form-fields/InputField/InputField";
import LabelScanningService from "./LabelScanningService";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import DefaultButton from "../../componentes/button/DefaultButton";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { BaseDialog } from "../../componentes/baseComponents/base-dialog/BaseDialog";
import { PrinterClientAutocomplete } from "../../componentes/autocomplete/PrinterClientAutocomplete";

export default function LabelScanningColoplast() {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        idClient: 1,
        barCode: '',
        quantity: '',
        checkbox1: false,
        checkbox2: false,
        status: 1,
        userId: userId,
        layout: 0,
        barCodProd: '',
        validade: '',
        lote: '',
        idPrinter: 0,
        open: false
    };

    const [printData, setPrintData] = useState(initialState);
    const [message, setMessage] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [validityDialogOpen, setValidityDialogOpen] = useState(false);
    const [onConfirmValidity, setOnConfirmValidity] = useState(null);


    const handleCloseAlert = () => {
        setError(false);
        setSuccess(false);
        setMessage("");
    };

    const handleClear = () => {
        setPrintData(initialState);
    };

    const handlePrintChange = (event) => {
        const { name, checked, type } = event.target;

        if (type === "checkbox") {
            if (checked) {
                // Se está marcando, desmarca o outro
                if (name === "checkbox1") {
                    setPrintData({ ...printData, checkbox1: true, checkbox2: false });
                } else if (name === "checkbox2") {
                    setPrintData({ ...printData, checkbox1: false, checkbox2: true });
                }
            } else {
                // Se está desmarcando, apenas desmarca o atual
                setPrintData({ ...printData, [name]: false });
            }
        } else {
            setPrintData({ ...printData, [name]: event.target.value });
        }
    };

    const handleBarcodeChange = (event) => {
        const { value } = event.target;
        setPrintData({ ...printData, barCode: value });
    };

    useEffect(() => {
        if (printData.barCode.length >= 32) {
            handlePrint();
        }
    }, [printData.barCode]);

    const geraEtiquetaZPL = (data) => {
        let dados = data;

        let request = {
            layout: printData.layout
        };
        LabelScanningService
            .getZPLColoplast(request)
            .then((response) => {
                let zpl = response.data;
                // Replace placeholders in the ZPL with actual data

                zpl = zpl.replace(/#Codigo#/g, dados[0].Codigo)
                    .replace(/#Registro#/g, dados[0].RegistroAnvisa)
                    .replace(/#Descricao#/g, dados[0].NomeProduto)
                    .replace(/#Advertencia#/g, dados[0].Advertencia)
                    .replace(/#Fabricante#/g, dados[0].NomeFabricante)
                    .replace(/#Importador_Nome#/g, dados[0].NomeDetentor)
                    .replace(/#Importador_Endereco#/g, dados[0].EnderecoDetentor)
                    .replace(/#CNPJ#/g, dados[0].Detentor2)
                    .replace(/#SAC#/g, dados[0].DetentorSAC)
                    .replace(/#Resp_Tecnico#/g, dados[0].NomeResponsavelTecnico)
                    .replace(/#Resp_CRF#/g, dados[0].CRF)
                    .replace(/#QRCODE#/g, printData.barCode)
                    .replace(/#EAN#/g, printData.barCodProd)
                    .replace(/#Validade#/g, printData.validade)
                    .replace(/#Lote#/g, printData.lote);

                debugger;
                // Fazer o insert da etiqueta pronta na tabela de impressão comforme o Cliente escolhido
                LabelScanningService
                    .insertZPLColoplast({
                        zpl: zpl,
                        idClient: printData.idClient,
                        userId: userId,
                        barCodProd: printData.barCodProd,
                        quantity: printData.quantity,
                        layout: printData.layout,
                        lote: printData.lote,
                        validade: printData.validade,
                        idImpressora: printData.idPrinter
                    })
                    .then((response) => {
                        setMessage(t("saveSuccess"));
                        setSuccess(true);
                        handleClear();
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            })
            .catch((e) => {
                console.log(e);
            });
    }


    const RealizaImpressao = () => {
        let request = {
            ...printData,
            userId: parseInt(userId),
            quantity: parseInt(printData.quantity)
        };

        LabelScanningService
            .getLabelColoplast(request)
            .then((response) => {
                geraEtiquetaZPL(response.data);
            })
            .catch((e) => {
                setMessage(t("printError"));
                setError(true);
            });
    }

    const openValidityDialog = (onConfirm) => {
        setOnConfirmValidity(() => onConfirm);
        setValidityDialogOpen(true);
    };

    const closeValidityDialog = () => {
        setValidityDialogOpen(false);
        setOnConfirmValidity(null);
    };

    const waitForValidityConfirmation = () => {
        return new Promise(resolve => {
            openValidityDialog(() => {
                resolve(); // Libera a execução
            });
        });
    };

    const handlePrint = async () => {
        if (printData.idClient === 0) {
            setMessage(t("invalidCustomer"));
            setError(true);
        } else if (printData.quantity === '' || isNaN(printData.quantity) || parseInt(printData.quantity) <= 0) {
            setMessage(t("invalidQuantity"));
            setError(true);
        } else if (!printData.checkbox1 && !printData.checkbox2) {
            setMessage(t("selectOptions"));
            setError(true);
        } else if (!printData.idPrinter) {
            setMessage(t("selectPrint"));
            setError(true);
        } else if (printData.barCode.length < 32) {
            setMessage(t("invalidBarcode"));
            setError(true);
        } else {
            const codigoStr = printData.barCode;
            let barCodProd = "";
            let validadeProd = "";
            let loteProd = "";

            // Tipo GSI
            const gsiMatch = codigoStr.match(/\(01\)(\d{14})\(17\)(\d{6})\(10\)([\dA-Z]+?)/);
            if (gsiMatch) {
                barCodProd = gsiMatch[1]; // Código de barras do produto
                validadeProd = gsiMatch[2]; // Validade do produto
                loteProd = gsiMatch[3]; // Lote do produto
            }

            // Tipo Normal
            const normalMatch = codigoStr.match(/01(\d{14})17(\d{6})10([\dA-Z]+)/);
            if (normalMatch) {
                barCodProd = normalMatch[1];
                validadeProd = normalMatch[2];
                loteProd = normalMatch[3];
            }

            // Tipo GG
            const ggMatch = codigoStr.match(/01(\d{14})11\d+17(\d{6})10([\dA-Z]+?)240/);
            if (ggMatch) {
                barCodProd = ggMatch[1]; // Código de barras
                validadeProd = ggMatch[2]; // Validade
                loteProd = ggMatch[3]; // Lote (sem o 240)
            }

            // Tipo Sem Validade (novo) - lote indicado pelo 21
            const semValidadeMatch = codigoStr.match(/01(\d{14})11\d+21([\dA-Z]+?)240/);
            if (semValidadeMatch) {
                barCodProd = semValidadeMatch[1];
                loteProd = semValidadeMatch[2];

                // Gerar validade automática (+10 anos)
                const hoje = new Date();
                hoje.setFullYear(hoje.getFullYear() + 10);

                const yy = String(hoje.getFullYear()).slice(-2);
                const mm = String(hoje.getMonth() + 1).padStart(2, "0");
                const dd = String(hoje.getDate()).padStart(2, "0");
                validadeProd = `${yy}${mm}${dd}`;

                // Esperar o usuário confirmar no diálogo
                await waitForValidityConfirmation();
            }

            if (!barCodProd || !validadeProd || !loteProd) {
                handleClear();
                setMessage(t("invalidBarcodeFormat"));
                setError(true);
                return;
            }

            try {

                // validadeProd vem no formato yyMMdd, ex: "240215"

                // Converter "yyMMdd" para Date
                const ano = parseInt(validadeProd.substring(0, 2), 10);
                const mes = parseInt(validadeProd.substring(2, 4), 10) - 1; // JS começa meses em 0
                const dia = parseInt(validadeProd.substring(4, 6), 10);

                // C# usa TwoDigitYearMax = 2099, então 00–99 viram 2000–2099
                const anoCompleto = 2000 + ano;

                const validade = new Date(anoCompleto, mes, dia);

                // Formatar como dd/MM/yyyy
                const validadeFormatada = validade.toLocaleDateString("pt-BR");

                printData.barCodProd = barCodProd;
                printData.validade = validadeFormatada;
                printData.lote = loteProd;

                if (printData.idClient === 1) {
                    // Client Coloplast
                    let request = {
                        barCode: barCodProd
                    }

                    LabelScanningService
                        .getProductColoplast(request)
                        .then((response) => {
                            // Etiqueta Convencional Escolhida
                            if (printData.checkbox1) {
                                printData.layout = 1;
                                RealizaImpressao();
                            }
                            // Etiqueta Rastreabilidade Escolhida
                            if (printData.checkbox2) {
                                printData.layout = 2;
                                RealizaImpressao();
                            }
                        })
                        .catch((e) => {
                            setMessage(t("productNotFound"));
                            setError(true);
                        });
                } else {
                    // Outros Clientes
                }
            }
            catch (error) {
                setMessage(t("printError"));
                setError(true);
            }
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setPrintData({ ...printData, [name]: value });
    };

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="labelScanning"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                error={error}
                                success={success}
                                message={message}
                                handleCloseAlert={handleCloseAlert}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={3}>
                                    <div style={{
                                        pointerEvents: "none",
                                        opacity: 0.8
                                    }}>
                                        <DefaultAutocomplete
                                            iconLabelSwitch={
                                                <IconLabelSwitch
                                                    name="unLock"
                                                    labelName="client"
                                                />
                                            }
                                            name="idClient"
                                            disabled={true}
                                            value={printData.idClient}
                                            defaultSize
                                            useApi
                                            endpoint='GetClient'
                                            error={printData.error && printData.idClient === 0}

                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <InputField
                                        name="quantity"
                                        label="qtde"
                                        control={control}
                                        type="number"
                                        defaultValue=""
                                        onChange={handlePrintChange}
                                        value={printData.quantity}
                                        error={error && (printData.quantity === '' || isNaN(printData.quantity) || parseInt(printData.quantity) <= 0)}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography >
                                        {t("selectOptions")}
                                    </Typography>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="checkbox1"
                                                checked={printData.checkbox1}
                                                onChange={handlePrintChange}
                                            />
                                        }
                                        label={t("conventionalLabelLayout")}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="checkbox2"
                                                checked={printData.checkbox2}
                                                onChange={handlePrintChange}
                                            />
                                        }
                                        label={t("traceabilityLabelLayout")}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <PrinterClientAutocomplete
                                        name="idPrinter"
                                        onChange={handleChange}
                                        value={printData.idPrinter}
                                        label={t("printer")}
                                        defaultSize
                                        useApi
                                        endPointData={{ idClient: printData.idClient }}
                                        endpoint='GetPrinterClient'
                                        error={error && printData.idPrinter === 0}
                                    />
                                </Grid>
                            </GridInputRow>
                            <GridInputRow>
                                <Grid item xs={16} sm={6} md={6}>
                                    <InputField
                                        name="barcode"
                                        label="Barcode"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleBarcodeChange}
                                        value={printData.barCode}
                                        error={error && printData.barCode.length < 32}
                                    />
                                </Grid>
                            </GridInputRow>
                            <Grid item xs={4} sm={3} md={2}>
                                <DefaultButton print className="primaryButton" onClick={handlePrint} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2}>
                                <DefaultButton clear className="secondaryButton" onClick={handleClear} />
                            </Grid>
                        </GridItemContainer>
                    </>
                }
            />

            <BaseDialog
                open={validityDialogOpen}
                onClose={closeValidityDialog}
                maxWidth="sm"
                fullWidth
                title={t("confirmValidity")}
                content={
                    <Typography>{t("addTenYearsToValidity")}</Typography>
                }
                actions={
                    <>
                        <Button
                            onClick={() => {
                                if (onConfirmValidity) {
                                    onConfirmValidity(); // dispara o resolve()
                                }
                                closeValidityDialog();
                            }}
                            color="primary"
                        >
                            {t("yes")}
                        </Button>
                        <Button onClick={closeValidityDialog} color="secondary">
                            {t("no")}
                        </Button>
                    </>
                }
            />
        </>
    );
};
